import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ChatContainer } from '../components/ChatContainer';
import { Layout } from '../components/Layout';
import { ApiConfig } from '../types/chat';
import { ConversationMessage } from '../utils/dynamodb';
// import { getCurrentEnvironmentConfig } from '../utils/featureFlags';

export const ChatPage: React.FC = () => {
  const [conversationTitle, setConversationTitle] = React.useState<
    string | null
  >(null);
  const [loadConversation, setLoadConversation] = React.useState<
    | ((
        messages: ConversationMessage[],
        sessionId: string,
        title?: string,
      ) => void)
    | null
  >(null);
  const location = useLocation();
  const navigate = useNavigate();
  const pendingConversationRef = React.useRef<{
    messages: ConversationMessage[];
    sessionId: string;
    title?: string;
  } | null>(null);

  const apiConfig: Partial<ApiConfig> = {};
  // const currentEnvConfig = getCurrentEnvironmentConfig();
  // const displayEndpoint =
  //   currentEnvConfig.apiEndpoint || currentEnvConfig.functionUrl;

  const handleLoadConversationReady = (
    loadFn: (
      messages: ConversationMessage[],
      sessionId: string,
      title?: string,
    ) => void,
  ) => {
    setLoadConversation(() => loadFn);
  };

  React.useEffect(() => {
    const state = location.state as
      | {
          preloadConversation?: {
            messages: ConversationMessage[];
            sessionId: string;
            title?: string;
          };
        }
      | undefined;

    if (state?.preloadConversation) {
      pendingConversationRef.current = state.preloadConversation;
    }
  }, [location.state]);

  React.useEffect(() => {
    if (loadConversation && pendingConversationRef.current) {
      const { messages, sessionId, title } = pendingConversationRef.current;
      loadConversation(messages, sessionId, title);
      pendingConversationRef.current = null;

      const state = location.state as { preloadConversation?: unknown } | null;
      if (state?.preloadConversation) {
        navigate(location.pathname, { replace: true, state: null });
      }
    }
  }, [loadConversation, location.pathname, location.state, navigate]);

  return (
    <Layout
      sidebar={true}
      conversationTitle={conversationTitle}
      onLoadConversation={loadConversation}
    >
      {/* Full height chat container */}
      <div className="h-full flex flex-col overflow-hidden">
        <div className="flex-1 min-h-0">
          <ChatContainer
            apiConfig={apiConfig}
            showTraces={true}
            maxMessages={100}
            className="h-full"
            onConversationTitleChange={setConversationTitle}
            onLoadConversationReady={handleLoadConversationReady}
          />
        </div>
        {/* 
        {process.env.NODE_ENV === 'development' && (
          <div className="text-xs text-gray-400 text-center py-1">
            Development Mode - API Endpoint: {displayEndpoint}
          </div>
        )} */}
      </div>
    </Layout>
  );
};
